import { ReceivedFileInterface } from '../FileInterface';
import { ProductInterface } from '../products';

import { OrderProductFileInterface } from './OrderProductFileInterface';

export interface OrderProductInterface {
    ORDERS_PRODUCTS_ID?: number;
    PRODUCT_ID?: number;
    ORDER_ID?: number;
    ESHOP_ORDER_PRODUCT_ID: string | null | undefined;
    COUNT: number;
    ITEM_ORDER?: number;
    PRODUCT_PRICE: number | null;
    PRODUCT_CURRENCY?: string;
    LOT: string | null;
    CONFIRMED?: string;
    MISSING_COUNT?: number;
    LINE_STATE?: string;
    EXTEND_PRODUCT_TYPE?: ExtendProductType | string | null;
    ORDER_CURRENCY_PRICE?: number | null;
    PRODUCT_NAME?: string;
    CUSTOMS_PRODUCT_TYPE: string | null;
    SERIAL_NUMBER?: string | null;
    CUSTOMIZATION_TYPE: CustomizationType | string | null;
    CUSTOMIZATION_TEXT: string | null;
    BCX_CODE: string | null;
    PRODUCT?: {
        SKU: string;
    };
    ID_SET?: number | null;
    /** When 1, row cannot be reactivated (LINE_STATE E) after deactivation by product type change or set breakdown. */
    REACTIVATION_BLOCKED?: number;
    ORDER_PRODUCT_FILES?: OrderProductFileInterface[];
}

export type OrderProductWithSKUAndName = Required<OrderProductInterface> &
    Pick<ProductInterface, 'SKU'> & { PRODUCT_NAME: string };

export interface OrderProductAndFilesInterface extends OrderProductInterface {
    FILES: ReceivedFileInterface[];
}

export const EXTEND_PRODUCT_TYPES = ['specificProduct', 'everyOrder', 'set'] as const;

export type ExtendProductType = (typeof EXTEND_PRODUCT_TYPES)[number];

export enum CustomizationType {
    engraving = 'engraving',
    stamping = 'stamping',
    grinding = 'grinding',
}

export interface PublicOrderProductInterface {
    productCode: string;
    count: number;
    productPrice: number;
}

export const isPublicOrderProductInterface = (
    data: PublicOrderProductInterface | OrderProductInterface
): data is PublicOrderProductInterface => 'count' in data;
